import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { handleFieldChange } from "../../../../Utils";
import FormOverlay from '../../../../components/FormOverlay';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';
import Icon from '../../../../components/Icon';

const typeOptions = {
    'bidder': 'Bidder',
    'bidder-clk': 'Bidder Click',
    'bidder-adk': 'Bidder ADK',
    'pushapi-eu': 'Pushapi EU',
    'pushapi-eu-clk': 'Pushapi EU Click',
    'pushapi-us': 'Pushapi US',
    'pushapi-us-clk': 'Pushapi US Click',
    'app': 'App Server',
    'ss': 'Send Server',
    'adk': 'ADK',
    'adk-EU': 'ADK EU',
    'adk-US': 'ADK US',
    'adk-SG': 'ADK SG',
    'adk-banner-EU': 'ADK Banner EU',
    'webserver': 'Webserver',
    'adk-haproxy': 'ADK HAProxy'
};

class Form extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            ip: '',
            type: ''
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();

        this.props.onSubmit(Object.assign({}, this.state));
    }

    render() {
        return (
            <FormOverlay onFormHide={this.props.onFormHide}>
                <form onSubmit={this.handleSubmit} style={{ height: "auto", maxWidth: "600px", overflowY: 'initial' }}>
                    <FieldGroup
                        name="name"
                        label="Name:"
                        onChange={this.handleFieldChange}
                        value={this.state.name}
                        required
                    />
                    <FieldGroup
                        name="ip"
                        label="IP:"
                        onChange={this.handleFieldChange}
                        value={this.state.ip}
                        required
                    />
                    <SelectWrap
                        value={this.state.type}
                        name="type"
                        label="Type:"
                        values={typeOptions}
                        onChange={this.handleFieldChange}
                    />
                    <Button className="pull-right" bsStyle="success" type="submit"><Icon name="floppy-o"/> Save</Button>
                </form>
            </FormOverlay>
        );
    }
}

export default Form;



// WEBPACK FOOTER //
// ./src/scenes/Servers/components/Form/index.js